<template>
  <v-row justify="center">
    <v-col cols="6">
      <v-card class="mt-4" flat>
        <v-card-title class="pl-0">
          <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>留言反馈
        </v-card-title>
        <v-card-text>
          <v-form ref="msgboardForm">
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="billData.title" outlined label="标题" :rules="[rules.required]" placeholder="请填写一个简短的标题" />
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="billData.content" outlined label="工单内容" :rules="[rules.required]" :placeholder="contentPlaceholder" />
              </v-col>
            </v-row>
            <v-row>
              <v-spacer />
              <v-btn class="mr-4" color="primary" large dark @click="onSubmit">提 交</v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable no-console */
import { required } from '@/plugins/rules';

import { userQaAdd } from '@/plugins/api';
export default {
  data () {
    return {
      billData: {},
      rules: { required: required() },
      contentPlaceholder: `请描述您在操作中遇到的困难：
      1：工具问题请您提供工具名称+任务号 
      2：项目问题请您提供YAS号＋项目组学名称（例如：蛋白、代谢、单细胞、空间、转录…） 
      3：请您输入操作中遇到的具体问题
      温馨提示：为了更迅速的解决您的问题，请您按上述要求填写留言反馈！`,
    }
  },
  methods: {
    onSubmit () {
      if (!this.$refs.msgboardForm.validate()) return;
      userQaAdd(this.billData).then(() => {
        this.$message.success('提交成功！');
        this.$router.push('/profile/msgboard');
      })
    },
  }
}
</script>